import FilterableForm from "../common/filterableForm";

interface PromocodeFilterProps {
  onClose: () => void;
}

function PromocodeFilter({ onClose }: PromocodeFilterProps) {  

  return (
    
    <FilterableForm
      title="Promocode Filters"
      fields={[
          { name: "id", label: "ID", type: "number", defaultValue: "" },
          { name: "code", label: "Code", type: "text", defaultValue: '' },
          { name: "value", label: "Value", type: "text", defaultValue: '' },
      ]}
      onClose={onClose}
    />



  );
}

export default PromocodeFilter;
